import React from 'react';
import {
    CheckboxWrapper,
    CheckboxContent,
    RemoveFundWrapper,
    CheckBoxMobileWrapper,
    CapsuleButtonWrapper
} from '../styles';
import { addnewFundDetails, clearfundDetails, changeFundDetails } from "../../../actions";
import { Form, Row, Col } from 'antd';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import PropTypes from "prop-types";
import { CapsuleButton } from "../../../../../../../CommonComponents/Commons/commonComponents";
import InputFundDetails from "../../CommonComponents/InputComponent/InputFundDetails";
import Complete from "../../CommonComponents/DropDownComponent/AutoComplete/AutoComplete";
import { CustomCheckbox } from '../../../../../../../CommonComponents/commonStyles';
import { recordError } from "../../../../../../../utils/commonUtil";

export class MutualFundForm extends React.Component {
    constructor(props) {
        super(props);
        this.generateContentforVGMF = this.generateContentforVGMF.bind(this);
        this.generateContentforVGSG = this.generateContentforVGSG.bind(this);
        this.addSameAccount = this.addSameAccount.bind(this);
        this.clearDetails = this.clearDetails.bind(this);
        this.removeFund = this.removeFund.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
             selectedAutoComplete: 0
        }
 }

    addSameAccount = (e) => {
        try {
            const storeData = this.props.fundInformation;
            if(storeData.length <= 20){       
                const fundInfo = {
                    tickerSymbol: "",
                    fundName: "",
                    fundNumber: "",
                    numberofShares: "",
                    isAutoFilled: false,
                    allShare:false,
                    cusip:null,
                    totalShares:-1
                }
                const giftInfo = {
                    tickerSymbol: "",
                    securityName: "",
                    numberofShares: "",
                    cusip:null,
                    allShare:false,
                    totalShares:-1
                }
                if (this.props.contributionType === "mutualFund")
                {
                    storeData.push(fundInfo);
                } else if (this.props.contributionType === "securityGift" || this.props.contributionType === "stockCertificateList")
                {
                    storeData.push(giftInfo);
                }
                this.props.addnewFundDetails(storeData);
            }
        } catch (error) {
          recordError(error);
        }
    }

    clearDetails = (index) => {
        this.props.clearfundDetails(index);
    }

    removeFund = (index) => {
        try {
            const storeData = this.props.fundInformation;
            storeData.splice(index,1);
            this.props.addnewFundDetails(storeData);
        } catch (error) {
          recordError(error);
        }
    }

    contributeAllShares = (e,id) => {
        let allShare =this.props.fundInformation[id].totalShares;
        if(e.target.checked === false){
            this.props.numberOfShares(id,allShare===-1?"":allShare);
            this.props.allShare(id,false);
        }else{
            this.props.numberOfShares(id ,allShare);
            this.props.allShare(id,true);
        }
    }
    openAutoComplete = (id) => {
        this.setState({
            selectedAutoComplete: id
        })
    }
    generateContentforVGMF(fund, index) {
        return (
            <>
                <Row>
                    <Col lg={{ span: 8 }} md={{ span: 8 }} > 
                    {(this.props.assetHeld === "assetHeldatVG" || this.props.assetHeld === "assetOutsideVG") ?                 
                        <Complete controller='ticker' selected={this.props.selected} assetHeld={this.props.assetHeld} accountId={this.props.accountId} inputId={index} property="tickerSymbol" label="Ticker symbol" fundType="fundInformation" contributionType={this.props.contributionType} placeholder = {"Enter ticker symbol"} selectedAutoComplete={this.state.selectedAutoComplete} handleOpenAutoComplete={this.openAutoComplete} completeId = {0} toolTip = {"A unique series of letters or numbers used to identify publicly traded stock"} unitPrice = {fund.unitPrice}/>
                        :
                        <InputFundDetails selected={this.props.selected} assetHeld={this.props.assetHeld} accountId={this.props.accountId} inputId={index} property="tickerSymbol" label="Ticker symbol" fundType="fundInformation" contributionType={this.props.contributionType} />
                    }
                    </Col>
                    <Col lg={{ span: 8, offset: 1 }} md={{ span: 8, offset: 1 }} >
                        {this.props.assetHeld === "assetHeldatVG" ?
                            <Complete controller="fundNumber" selected={this.props.selected} assetHeld={this.props.assetHeld} accountId={this.props.accountId} inputId={index} property="fundNumber" label={ this.props.assetHeld === "assetHeldatVG" ? "Fund number" : "Fund number (optional)"} fundType="fundInformation" contributionType={this.props.contributionType} />
                            :
                            (this.props.assetHeld === "assetOutsideVG" ?
                            <Complete controller="name" selected={this.props.selected} assetHeld={this.props.assetHeld} accountId={this.props.accountId} inputId={index} property="fundName" label="Fund name" fundType="fundInformation" contributionType={this.props.contributionType} placeholder = {"Enter fund name"} selectedAutoComplete={this.state.selectedAutoComplete} handleOpenAutoComplete={this.openAutoComplete} completeId = {3} toolTip = {"The name of the mutual fund you wish to give"} unitPrice = {fund.unitPrice}/>
                            :
                            <InputFundDetails selected={this.props.selected} assetHeld={this.props.assetHeld} accountId={this.props.accountId} inputId={index} property="fundName" label="Fund name" fundType="fundInformation" contributionType={this.props.contributionType} />
                            )
                        }
                    </Col>
                </Row>
                <Row>
                    <Col lg={{ span: 8 }} md={{ span: 8 }}>
                    {this.props.assetHeld === "assetHeldatVG" ?
                        <Complete controller="fundName" selected={this.props.selected} assetHeld={this.props.assetHeld} accountId={this.props.accountId} inputId={index} property="fundName" label="Fund name" fundType="fundInformation" contributionType={this.props.contributionType} />
                        :
                        <InputFundDetails selected={this.props.selected} assetHeld={this.props.assetHeld} accountId={this.props.accountId} inputId={index} property="numberofShares" label="Number of shares" fundType="fundInformation" contributionType={this.props.contributionType}  allShare={this.props.fundInformation[index].allShare}/>
                    }
                    </Col>
                    <Col lg={{ span: 8, offset: 1 }} md={{ span: 8, offset: 1 }}>
                    {this.props.assetHeld === "assetHeldatVG" ? 
                    <InputFundDetails selected={this.props.selected} assetHeld={this.props.assetHeld} accountId={this.props.accountId} inputId={index} property="numberofShares" label="Number of shares" fundType="fundInformation" contributionType={this.props.contributionType}  allShare={this.props.fundInformation[index].allShare}/>
                     :        
                     this.props.assetHeld === "assetOutsideVG"?
                      <InputFundDetails selected={this.props.selected} assetHeld={this.props.assetHeld} accountId={this.props.accountId} inputId={index} property="approxAmount" label="Estimated dollar amount" fundType="fundInformation" contributionType={this.props.contributionType} disabled={true} shareNumber={fund.shareNumber} unitPrice = {fund.unitPrice} selTicker = {fund.tickerSymbol} selDate = {fund.tickerClosingDate}/>
                    : <InputFundDetails selected={this.props.selected} assetHeld={this.props.assetHeld} accountId={this.props.accountId} inputId={index} property="fundNumber" label={ this.props.assetHeld === "assetHeldatVG" ? "Fund number" : "Fund number (optional)"} fundType="fundInformation" contributionType={this.props.contributionType} />

                    }
                    </Col>
                </Row>
                {(this.props.assetHeld === "assetOutsideVG")?
                  <Row>
                  <Col lg={{ span: 8 }} md={{ span: 8 }}>
                     <InputFundDetails selected={this.props.selected} assetHeld={this.props.assetHeld} accountId={this.props.accountId} inputId={index} property="fundNumber" label={ this.props.assetHeld === "assetHeldatVG" ? "Fund number" : "Fund number (optional)"} fundType="fundInformation" contributionType={this.props.contributionType} />
                     </Col>
                 </Row>:""
                }
                {this.props.assetHeld === "assetHeldatVG" ? 
                <Row>
                    <Col>
                        <CheckboxWrapper marginBottom="30px" mb="20px"><CustomCheckbox id="chkContributeAll" data-test='check-box' onChange={(e) => this.contributeAllShares(e,index)} checked={this.props.fundInformation[index].allShare}></CustomCheckbox><CheckBoxMobileWrapper><CheckboxContent marginLeft="15px">Please check here if your intent is to contribute all shares of this fund from this account. </CheckboxContent></CheckBoxMobileWrapper></CheckboxWrapper>
                    </Col>
                </Row>
                : "" }
                {(index !== 0) ?
                <Row>
                    <RemoveFundWrapper>
                        <CapsuleButton 
                            data-test='stock-btn'
                            text= {this.props.assetHeld === "stockCertificate" ? "Remove Certificate" : "Remove Fund"}
                            id={"button"+index} 
                            onClick={e => this.removeFund(index)}
                    />
                    </RemoveFundWrapper>
                </Row>
                : null
                }
            </>
        )
    }

    generateContentforVGSG(fund, index) {
        return (<>
            <Row>
                <Col lg={{ span: 8 }} md={{ span: 8 }} >
                    {this.props.assetHeld === "assetOutsideVG"? <Complete controller='ticker' selected={this.props.selected} assetHeld={this.props.assetHeld} accountId={this.props.accountId} inputId={index} property="tickerSymbol" label="Ticker symbol" fundType="fundInformation" contributionType={this.props.contributionType} placeholder = {"Enter ticker symbol"} selectedAutoComplete={this.state.selectedAutoComplete} handleOpenAutoComplete={this.openAutoComplete} data-test='input-fund' completeId = {0} toolTip = {"A unique series of letters or numbers used to identify publicly traded stock"} unitPrice = {fund.unitPrice}/>
                    : <InputFundDetails selected={this.props.selected} assetHeld={this.props.assetHeld} accountId={this.props.accountId} inputId={index} property="tickerSymbol" label="Ticker symbol" fundType="fundInformation" contributionType={this.props.contributionType} />
                    }
                </Col>
                <Col lg={{ span: 8, offset: 1 }} md={{ span: 8, offset: 1 }} >
                    {this.props.assetHeld === "assetOutsideVG"? <Complete controller='name' selected={this.props.selected} assetHeld={this.props.assetHeld} accountId={this.props.accountId} inputId={index} property="securityName" label= "Security name" fundType="fundInformation" contributionType={this.props.contributionType} placeholder = {"Enter security name"} selectedAutoComplete={this.state.selectedAutoComplete} completeId = {1} handleOpenAutoComplete={this.openAutoComplete} toolTip = {"Name of the tradable asset you wish to give"} unitPrice = {fund.unitPrice}/>
                    : <InputFundDetails selected={this.props.selected} assetHeld={this.props.assetHeld} accountId={this.props.accountId} inputId={index} property="securityName" label="Security name" fundType="fundInformation" contributionType={this.props.contributionType} />
                    }                   
                </Col>
            </Row>
            <Row>
                <Col lg={{ span: 8 }} md={{ span: 8 }}>
                    <InputFundDetails selected={this.props.selected} assetHeld={this.props.assetHeld} accountId={this.props.accountId} inputId={index} property="numberofShares" label="Number of shares" fundType="fundInformation" contributionType={this.props.contributionType} allShare={this.props.fundInformation[index].allShare}/>
                </Col>
                {(this.props.assetHeld === "assetOutsideVG")?
                  <Col lg={{ span: 8, offset: 1 }} md={{ span: 8, offset: 1 }}>
                    <InputFundDetails selected={this.props.selected} assetHeld={this.props.assetHeld} accountId={this.props.accountId} inputId={index} property="approxAmount" label="Estimated dollar amount" fundType="fundInformation" contributionType={this.props.contributionType} disabled={true} shareNumber={fund.shareNumber} unitPrice = {fund.unitPrice} selTicker = {fund.tickerSymbol}  selDate = {fund.tickerClosingDate}/>
                     </Col>
                    :
                     ""}
            </Row>
            {this.props.assetHeld === "assetHeldatVG" ? 
            <Row>
                    <Col>
                        <CheckboxWrapper marginBottom="30px" mb="20px"><CustomCheckbox id="chkAllShare" onChange={(e) => this.contributeAllShares(e,index)} checked={this.props.fundInformation[index].allShare}> </CustomCheckbox><CheckboxContent marginLeft="0px" mLB="-6px">All shares. </CheckboxContent></CheckboxWrapper>
                    </Col>
                </Row>
           : "" }
            {(index !== 0) ?
                <Row>
                    <RemoveFundWrapper>
                    <CapsuleButton 
                        text= {this.props.assetHeld === "stockCertificate" ? "Remove Certificate" : "Remove Security"}
                        id={"button"+index} 
                        onClick={e => this.removeFund(index)}
                    />
                    </RemoveFundWrapper>
                </Row>
                : null
            }
        </>
        )
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
          if (!err) {
            
          }
        });
      }

    render() {
        let buttonName = "";
        if (this.props.assetHeld === "stockCertificate")
        {
            buttonName = "Add another certificate (same registration)";

        } else if(this.props.assetHeld === "assetHeldatVG"){
            if(this.props.contributionType === "mutualFund"){
                buttonName = "Add another mutual fund account (same account)";
            }else{
                buttonName = "Add another security (same account)";
            }
        }else if(this.props.assetHeld === "assetOutsideVG"){
            if(this.props.contributionType === "mutualFund"){
                buttonName = "Add another mutual fund gift (same account)";
            }else{
                buttonName = "Add another security gift (same account)";
            }
        }
        return (
            <>
                {this.props.fundInformation.map((fund, index) => (
                    (this.props.contributionType === "mutualFund" ? this.generateContentforVGMF(fund, index) : this.generateContentforVGSG(fund, index))
                ))}
                <CapsuleButtonWrapper marginBottom="30px">
                    <CapsuleButton 
                        data-test='add-btn'
                        text= {buttonName}
                        iconType="add"
                        mobHeight={true}
                        padding="5px 20px"
                        disabled={this.props.fundInformation.length === 20 ? true : false}
                        onClick={e => this.addSameAccount(e)}
                        id={`btn${buttonName.split(' ').join('')}`}
                    />
                </CapsuleButtonWrapper>
            </>
        )
    }
}

const MutualFund = Form.create({ name: "assetHeldAtVanguardMutualFUnd" })(MutualFundForm);

MutualFund.propTypes = {
    fundInformation: PropTypes.array,
    addnewFundDetails: PropTypes.func,
    clearfundDetails: PropTypes.func,
    numberOfShares: PropTypes.func,
    allShare: PropTypes.func,
}

const mapStateToProps = (state, ownProps) => {
    return {
        fundInformation: state.getIn(["makeAContribution", "contributionTypes", `${ownProps.assetHeld}`, `${ownProps.contributionType}`, `${ownProps.accountId}`, "fundInformation"]),
        priceInfo: state.getIn(["makeAContribution", "contributionTypes", `${ownProps.assetHeld}`, `${ownProps.contributionType}`, `${ownProps.accountId}`, "approxAmount"])

    }
};

export const mapDispatchToProps = (dispatch, ownProps) => ({
    addnewFundDetails: arr => dispatch(addnewFundDetails({ value: arr, accountId: ownProps.accountId, contributionType: ownProps.contributionType, assetHeld: ownProps.assetHeld })),
    clearfundDetails: index => dispatch(clearfundDetails({ index: index , accountId: ownProps.accountId, contributionType: ownProps.contributionType, assetHeld: ownProps.assetHeld })),
    numberOfShares: (e ,value) => dispatch(changeFundDetails({value:value ,property:"numberofShares", inputId:e, accountId:ownProps.accountId, fundType:"fundInformation", contributionType: ownProps.contributionType, assetHeld: ownProps.assetHeld })),
    allShare: (e ,value) => dispatch(changeFundDetails({value:value ,property:"allShare", inputId:e, accountId:ownProps.accountId, fundType:"fundInformation", contributionType: ownProps.contributionType, assetHeld: ownProps.assetHeld })),
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MutualFund));
